import { render, staticRenderFns } from "./CerReciboPago.vue?vue&type=template&id=043e7bc4"
import script from "./CerReciboPago.vue?vue&type=script&lang=js"
export * from "./CerReciboPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports